import PropTypes from 'prop-types';

import { cn } from '#/lib/utils';
import ResponsiveHint from '#/modules/commonComponents/hint/ResponsiveHint';

function isEmptyLabel(text) {
  return !text || text === '—' || text === '-';
}

/**
 * 表格／資訊格截斷文字 + tip（桌面 Tooltip／觸控 Popover）。
 * 可選雙擊開新分頁（detailPath）。
 */
const TruncatedTextWithTooltip = ({
  text,
  detailPath = null,
  onNavigate = null,
  truncate = true,
  tooltipContent,
  contentClassName,
  className,
}) => {
  const label = text || '—';
  const canNavigate = Boolean(detailPath || onNavigate) && !isEmptyLabel(label);

  function handleNavigate() {
    if (!canNavigate) {
      return;
    }
    if (onNavigate) {
      onNavigate();
      return;
    }
    window.open(detailPath, '_blank', 'noopener,noreferrer');
  }

  const content = (
    <span
      role={canNavigate ? 'link' : undefined}
      tabIndex={canNavigate ? 0 : undefined}
      className={cn(
        truncate && 'inline-block w-fit max-w-full truncate',
        !truncate && 'inline-block w-fit',
        className,
        canNavigate && 'cursor-pointer text-primary-600 hover:underline',
      )}
      onDoubleClick={canNavigate ? handleNavigate : undefined}
      onKeyDown={canNavigate ? (event) => {
        if (event.key === 'Enter') {
          handleNavigate();
        }
      } : undefined}
    >
      {label}
    </span>
  );

  // 未傳 tooltipContent → 以 text 為 tip；空標籤不包 tip。
  // 明確傳 null／空 → 不顯示 tip（如 BOM 無連結時）。
  const tip = tooltipContent !== undefined
    ? tooltipContent
    : (isEmptyLabel(label) ? null : text);

  if (!tip) {
    return content;
  }

  return (
    <ResponsiveHint content={tip} contentClassName={contentClassName}>
      {content}
    </ResponsiveHint>
  );
};

TruncatedTextWithTooltip.propTypes = {
  text: PropTypes.string,
  detailPath: PropTypes.string,
  onNavigate: PropTypes.func,
  truncate: PropTypes.bool,
  tooltipContent: PropTypes.node,
  contentClassName: PropTypes.string,
  className: PropTypes.string,
};

export default TruncatedTextWithTooltip;
